// ═══════════════════════════════════════════════════════════════
// AI POLICE — WORKFLOWS & NEXT-STEP BUTTONS
// Statische workflow stappen per module (Fase 1)
// ═══════════════════════════════════════════════════════════════

// Workflow steps per module
export const WORKFLOWS = {
  // ── KERN ──
  aangifte: [
    { id: 1, nl: 'Type delict selecteren',     en: 'Select offense type' },
    { id: 2, nl: 'Verklaring opnemen',         en: 'Take statement' },
    { id: 3, nl: 'Bewijsmateriaal toevoegen',  en: 'Add evidence' },
    { id: 4, nl: 'PV concept genereren',       en: 'Generate PV draft' },
    { id: 5, nl: 'Review & ondertekening',     en: 'Review & sign' },
  ],
  dossier: [
    { id: 1, nl: 'Zaken selecteren',           en: 'Select cases' },
    { id: 2, nl: 'Documenten koppelen',        en: 'Link documents' },
    { id: 3, nl: 'Volledigheidscheck',         en: 'Completeness check' },
    { id: 4, nl: 'Samenvatting genereren',     en: 'Generate summary' },
    { id: 5, nl: 'Export naar OM',             en: 'Export to prosecutor' },
  ],

  // ── ONDERZOEK ──
  verhoor: [
    { id: 1, nl: 'Verhoor starten',            en: 'Start interview' },
    { id: 2, nl: 'Live transcript',            en: 'Live transcript' },
    { id: 3, nl: 'Inconsistenties checken',    en: 'Check inconsistencies' },
    { id: 4, nl: 'Samenvatting & PV',          en: 'Summary & PV' },
  ],
  incident: [
    { id: 1, nl: 'Incident inspreken',         en: 'Dictate incident' },
    { id: 2, nl: 'Structureren',               en: 'Structure data' },
    { id: 3, nl: 'Categoriseren',              en: 'Categorize' },
    { id: 4, nl: 'Mutatie aanmaken',           en: 'Create record' },
  ],
  camera: [
    { id: 1, nl: 'Beelden selecteren',         en: 'Select footage' },
    { id: 2, nl: 'Tijdlijn markeren',          en: 'Mark timeline' },
    { id: 3, nl: 'Beschrijving genereren',     en: 'Generate description' },
    { id: 4, nl: 'Aan dossier koppelen',       en: 'Link to case file' },
  ],
  beslag: [
    { id: 1, nl: 'Type goed selecteren',       en: 'Select item type' },
    { id: 2, nl: 'Registratie invullen',       en: 'Complete registration' },
    { id: 3, nl: 'Foto\'s toevoegen',          en: 'Add photos' },
    { id: 4, nl: 'Bewaarplaats toewijzen',     en: 'Assign storage' },
    { id: 5, nl: 'Kwitantie genereren',        en: 'Generate receipt' },
  ],

  // ── OPERATIONEEL ──
  signalering: [
    { id: 1, nl: 'Type signalering kiezen',    en: 'Choose alert type' },
    { id: 2, nl: 'Gegevens invoeren',          en: 'Enter details' },
    { id: 3, nl: 'Urgentie bepalen',           en: 'Set urgency level' },
    { id: 4, nl: 'Signalering verzenden',      en: 'Send alert' },
  ],
  briefing: [
    { id: 1, nl: 'Periode selecteren',         en: 'Select period' },
    { id: 2, nl: 'Incidenten samenvatten',     en: 'Summarize incidents' },
    { id: 3, nl: 'Aandachtspunten toevoegen',  en: 'Add highlights' },
    { id: 4, nl: 'Briefing genereren',         en: 'Generate briefing' },
  ],
  planning: [
    { id: 1, nl: 'Dienstperiode kiezen',       en: 'Select shift period' },
    { id: 2, nl: 'Bezetting controleren',      en: 'Check staffing' },
    { id: 3, nl: 'Knelpunten oplossen',        en: 'Resolve conflicts' },
    { id: 4, nl: 'Rooster publiceren',         en: 'Publish schedule' },
  ],
  vergunning: [
    { id: 1, nl: 'Aanvraag type selecteren',   en: 'Select permit type' },
    { id: 2, nl: 'Gegevens controleren',       en: 'Verify details' },
    { id: 3, nl: 'Beoordeling uitvoeren',      en: 'Perform assessment' },
    { id: 4, nl: 'Besluit genereren',          en: 'Generate decision' },
  ],

  // ── KENNIS ──
  kennis: [
    { id: 1, nl: 'Onderwerp selecteren',       en: 'Select topic' },
    { id: 2, nl: 'Informatie opzoeken',        en: 'Look up information' },
    { id: 3, nl: 'Samenvatting bekijken',      en: 'View summary' },
  ],
  slachtoffer: [
    { id: 1, nl: 'Situatie beschrijven',       en: 'Describe situation' },
    { id: 2, nl: 'Rechten uitleggen',          en: 'Explain rights' },
    { id: 3, nl: 'Doorverwijzing genereren',   en: 'Generate referral' },
  ],

  // ── BURGER MODULES ──
  b_aangifte: [
    { id: 1, nl: 'Wat is er gebeurd?',         en: 'What happened?' },
    { id: 2, nl: 'Gegevens invullen',          en: 'Fill in details' },
    { id: 3, nl: 'Aangifte afronden',          en: 'Complete report' },
  ],
  b_rechten: [
    { id: 1, nl: 'Situatie kiezen',            en: 'Choose situation' },
    { id: 2, nl: 'Rechten bekijken',           en: 'View rights' },
    { id: 3, nl: 'Meer informatie',            en: 'More information' },
  ],
  b_cyber: [
    { id: 1, nl: 'Type cybercrime kiezen',     en: 'Select cybercrime type' },
    { id: 2, nl: 'Hulpstappen bekijken',       en: 'View help steps' },
    { id: 3, nl: 'Aangifte doen',              en: 'File a report' },
  ],
  b_slachtoffer: [
    { id: 1, nl: 'Situatie beschrijven',       en: 'Describe situation' },
    { id: 2, nl: 'Hulporganisatie vinden',     en: 'Find support org' },
    { id: 3, nl: 'Contact opnemen',            en: 'Contact support' },
  ],
};

// ═══════════════════════════════════════════════════════════════
// NEXT-STEP BUTTONS — 3 knoppen per module per stap
// ═══════════════════════════════════════════════════════════════

export const NEXT_BUTTONS = {
  // ── AANGIFTE & PV ──
  aangifte: {
    1: [
      { nl: '🏠 Inbraak',          en: '🏠 Burglary',       action: 'select_inbraak' },
      { nl: '🚲 Diefstal',         en: '🚲 Theft',          action: 'select_diefstal' },
      { nl: '💻 Cybercrime',       en: '💻 Cybercrime',     action: 'select_cyber' },
    ],
    2: [
      { nl: '🎤 Verklaring inspreken', en: '🎤 Dictate statement', action: 'dictate' },
      { nl: '👤 Getuige toevoegen',    en: '👤 Add witness',       action: 'add_witness' },
      { nl: '📋 Concept bekijken',     en: '📋 View draft',        action: 'view_draft' },
    ],
    3: [
      { nl: '📷 Foto toevoegen',   en: '📷 Add photo',      action: 'add_photo' },
      { nl: '📹 Video koppelen',   en: '📹 Link video',     action: 'link_video' },
      { nl: '➡️ Door naar PV',     en: '➡️ Proceed to PV',  action: 'next_step' },
    ],
    4: [
      { nl: '✏️ PV aanpassen',     en: '✏️ Edit PV',        action: 'edit_pv' },
      { nl: '✅ Goedkeuren',       en: '✅ Approve',         action: 'approve' },
      { nl: '📄 PDF downloaden',   en: '📄 Download PDF',   action: 'download' },
    ],
    5: [
      { nl: '📤 Verzenden naar OM', en: '📤 Send to prosecutor', action: 'send_om' },
      { nl: '📋 Nieuw PV starten',  en: '📋 Start new PV',       action: 'reset' },
      { nl: '📊 Overzicht',         en: '📊 Overview',            action: 'overview' },
    ],
  },

  // ── DOSSIERVORMING ──
  dossier: {
    1: [
      { nl: '🔍 Zaak zoeken',      en: '🔍 Search case',    action: 'search' },
      { nl: '📁 Recente zaken',    en: '📁 Recent cases',   action: 'recent' },
      { nl: '➕ Nieuw dossier',    en: '➕ New case file',   action: 'new' },
    ],
    2: [
      { nl: '📝 PV\'s koppelen',   en: '📝 Link PVs',       action: 'link_pv' },
      { nl: '📷 Bewijsstukken',    en: '📷 Evidence',        action: 'evidence' },
      { nl: '🎙️ Verhoorverslagen', en: '🎙️ Interviews',     action: 'interviews' },
    ],
    3: [
      { nl: '✅ Check uitvoeren',  en: '✅ Run check',       action: 'check' },
      { nl: '⚠️ Ontbrekende stukken', en: '⚠️ Missing items', action: 'missing' },
      { nl: '📄 Checklist bekijken',   en: '📄 View checklist', action: 'checklist' },
    ],
    4: [
      { nl: '📝 Samenvatting bewerken', en: '📝 Edit summary', action: 'edit' },
      { nl: '📊 Tijdlijn genereren',    en: '📊 Generate timeline', action: 'timeline' },
      { nl: '➡️ Naar export',           en: '➡️ To export',     action: 'next_step' },
    ],
    5: [
      { nl: '📤 Exporteren naar OM', en: '📤 Export to prosecutor', action: 'export' },
      { nl: '📄 PDF genereren',     en: '📄 Generate PDF',          action: 'pdf' },
      { nl: '📋 Nieuw dossier',     en: '📋 New case file',         action: 'reset' },
    ],
  },

  // ── VERHOOR TRANSCRIPTIE ──
  verhoor: {
    1: [
      { nl: '🎙️ Opname starten',     en: '🎙️ Start recording',  action: 'record' },
      { nl: '📝 Handmatig typen',    en: '📝 Type manually',    action: 'manual' },
      { nl: '⚖️ Rechten voorlezen',  en: '⚖️ Read rights',      action: 'rights' },
    ],
    2: [
      { nl: '⏸️ Pauzeren',           en: '⏸️ Pause',            action: 'pause' },
      { nl: '🔖 Markering plaatsen', en: '🔖 Add bookmark',     action: 'bookmark' },
      { nl: '⏹️ Verhoor beëindigen', en: '⏹️ End interview',    action: 'end' },
    ],
    3: [
      { nl: '⚠️ Details bekijken',   en: '⚠️ View details',     action: 'details' },
      { nl: '🔄 Vergelijken',        en: '🔄 Compare',          action: 'compare' },
      { nl: '📄 Naar samenvatting',  en: '📄 To summary',       action: 'next_step' },
    ],
    4: [
      { nl: '📋 PV van verhoor',    en: '📋 Interview PV',      action: 'pv' },
      { nl: '📤 Aan dossier toevoegen', en: '📤 Add to case file', action: 'add_dossier' },
      { nl: '🎙️ Nieuw verhoor',     en: '🎙️ New interview',     action: 'reset' },
    ],
  },

  // ── INCIDENT REGISTRATIE ──
  incident: {
    1: [
      { nl: '🎤 Inspreken',         en: '🎤 Dictate',          action: 'dictate' },
      { nl: '📝 Typen',             en: '📝 Type',             action: 'type' },
      { nl: '📋 Template gebruiken', en: '📋 Use template',    action: 'template' },
    ],
    2: [
      { nl: '📍 Locatie toevoegen', en: '📍 Add location',     action: 'location' },
      { nl: '👤 Betrokkenen',       en: '👤 Involved parties', action: 'parties' },
      { nl: '🕐 Tijdlijn',         en: '🕐 Timeline',         action: 'timeline' },
    ],
    3: [
      { nl: '🏷️ Categorie kiezen',  en: '🏷️ Choose category', action: 'category' },
      { nl: '⚡ Prioriteit instellen', en: '⚡ Set priority',  action: 'priority' },
      { nl: '➡️ Naar mutatie',      en: '➡️ To record',        action: 'next_step' },
    ],
    4: [
      { nl: '📤 Mutatie indienen',  en: '📤 Submit record',    action: 'submit' },
      { nl: '📋 Aan dossier koppelen', en: '📋 Link to case file', action: 'link' },
      { nl: '🚨 Nieuw incident',    en: '🚨 New incident',     action: 'reset' },
    ],
  },

  // ── CAMERABEELDEN ──
  camera: {
    1: [
      { nl: '📁 Bestand uploaden',  en: '📁 Upload file',      action: 'upload' },
      { nl: '🔗 URL invoeren',      en: '🔗 Enter URL',        action: 'url' },
      { nl: '📹 Live camera',       en: '📹 Live camera',      action: 'live' },
    ],
    2: [
      { nl: '⏱️ Begin markeren',    en: '⏱️ Mark start',       action: 'mark_start' },
      { nl: '⏱️ Einde markeren',    en: '⏱️ Mark end',         action: 'mark_end' },
      { nl: '📎 Fragment knippen',  en: '📎 Cut fragment',     action: 'cut' },
    ],
    3: [
      { nl: '📝 Beschrijving bewerken', en: '📝 Edit description', action: 'edit' },
      { nl: '👤 Personen identificeren', en: '👤 Identify persons', action: 'identify' },
      { nl: '➡️ Koppelen aan dossier',  en: '➡️ Link to case',     action: 'next_step' },
    ],
    4: [
      { nl: '📤 Opslaan in dossier', en: '📤 Save to case file', action: 'save' },
      { nl: '📄 Rapport genereren',  en: '📄 Generate report',   action: 'report' },
      { nl: '📹 Volgende beelden',   en: '📹 Next footage',      action: 'reset' },
    ],
  },

  // ── BESLAGNAME ──
  beslag: {
    1: [
      { nl: '💊 Verdovende middelen', en: '💊 Narcotics',       action: 'narcotics' },
      { nl: '🔫 Wapens',             en: '🔫 Weapons',          action: 'weapons' },
      { nl: '💰 Geld / Waardevolle goederen', en: '💰 Money / Valuables', action: 'valuables' },
    ],
    2: [
      { nl: '📝 Details invullen',   en: '📝 Fill in details',  action: 'details' },
      { nl: '📏 Hoeveelheid / Gewicht', en: '📏 Quantity / Weight', action: 'quantity' },
      { nl: '📍 Vindplaats noteren', en: '📍 Note location',    action: 'location' },
    ],
    3: [
      { nl: '📷 Foto nemen',        en: '📷 Take photo',       action: 'photo' },
      { nl: '📹 Video opnemen',     en: '📹 Record video',     action: 'video' },
      { nl: '➡️ Naar bewaarplaats',  en: '➡️ To storage',       action: 'next_step' },
    ],
    4: [
      { nl: '🏢 Bewaarplaats kiezen', en: '🏢 Choose storage', action: 'storage' },
      { nl: '📋 Code toewijzen',      en: '📋 Assign code',    action: 'code' },
      { nl: '➡️ Naar kwitantie',      en: '➡️ To receipt',     action: 'next_step' },
    ],
    5: [
      { nl: '🖨️ Kwitantie printen',  en: '🖨️ Print receipt',  action: 'print' },
      { nl: '📤 Aan dossier koppelen', en: '📤 Link to case',  action: 'link' },
      { nl: '🏷️ Nieuw beslag',       en: '🏷️ New seizure',    action: 'reset' },
    ],
  },

  // ── SIGNALERINGEN ──
  signalering: {
    1: [
      { nl: '👤 Persoon',           en: '👤 Person',           action: 'person' },
      { nl: '🚗 Voertuig',          en: '🚗 Vehicle',          action: 'vehicle' },
      { nl: '📦 Object',            en: '📦 Object',           action: 'object' },
    ],
    2: [
      { nl: '📝 Signalement invullen', en: '📝 Enter description', action: 'describe' },
      { nl: '📷 Foto toevoegen',    en: '📷 Add photo',        action: 'photo' },
      { nl: '🔗 Aan zaak koppelen', en: '🔗 Link to case',     action: 'link' },
    ],
    3: [
      { nl: '🔴 Spoed',             en: '🔴 Urgent',           action: 'urgent' },
      { nl: '🟡 Regulier',          en: '🟡 Regular',          action: 'regular' },
      { nl: '🟢 Informatief',       en: '🟢 Informational',    action: 'info' },
    ],
    4: [
      { nl: '📤 Landelijk verspreiden', en: '📤 Distribute nationally', action: 'national' },
      { nl: '📍 Regionaal beperken',    en: '📍 Regional only',          action: 'regional' },
      { nl: '🔍 Nieuwe signalering',    en: '🔍 New alert',              action: 'reset' },
    ],
  },

  // ── BRIEFINGS ──
  briefing: {
    1: [
      { nl: '🌅 Ochtend',           en: '🌅 Morning',          action: 'morning' },
      { nl: '🌇 Middag',            en: '🌇 Afternoon',        action: 'afternoon' },
      { nl: '🌙 Nacht',             en: '🌙 Night',            action: 'night' },
    ],
    2: [
      { nl: '📊 Auto-samenvatting', en: '📊 Auto-summary',     action: 'auto' },
      { nl: '✏️ Handmatig toevoegen', en: '✏️ Add manually',   action: 'manual' },
      { nl: '⚠️ Alleen prioriteiten', en: '⚠️ Priorities only', action: 'priorities' },
    ],
    3: [
      { nl: '🎯 Actiepunten',       en: '🎯 Action items',     action: 'actions' },
      { nl: '⚠️ Waarschuwingen',    en: '⚠️ Warnings',         action: 'warnings' },
      { nl: '📍 Gebiedsinfo',       en: '📍 Area info',         action: 'area' },
    ],
    4: [
      { nl: '📄 PDF genereren',     en: '📄 Generate PDF',     action: 'pdf' },
      { nl: '📧 E-mail versturen',  en: '📧 Send email',       action: 'email' },
      { nl: '📊 Nieuwe briefing',   en: '📊 New briefing',     action: 'reset' },
    ],
  },

  // ── PLANNING & ROOSTERING ──
  planning: {
    1: [
      { nl: '📅 Deze week',         en: '📅 This week',        action: 'week' },
      { nl: '📅 Volgende week',     en: '📅 Next week',        action: 'next_week' },
      { nl: '📅 Maand overzicht',   en: '📅 Month overview',   action: 'month' },
    ],
    2: [
      { nl: '👥 Beschikbaarheid',   en: '👥 Availability',     action: 'availability' },
      { nl: '📊 Minimumbezetting',  en: '📊 Min. staffing',    action: 'minimum' },
      { nl: '⚠️ Onderbezetting',    en: '⚠️ Understaffing',    action: 'understaffing' },
    ],
    3: [
      { nl: '🔄 Dienst ruilen',     en: '🔄 Swap shift',       action: 'swap' },
      { nl: '➕ Extra inzet',       en: '➕ Extra deployment',  action: 'extra' },
      { nl: '✅ Goedkeuren',        en: '✅ Approve',           action: 'approve' },
    ],
    4: [
      { nl: '📤 Publiceren',        en: '📤 Publish',          action: 'publish' },
      { nl: '📧 Team notificeren',  en: '📧 Notify team',      action: 'notify' },
      { nl: '📅 Nieuw rooster',     en: '📅 New schedule',     action: 'reset' },
    ],
  },

  // ── VERGUNNINGEN ──
  vergunning: {
    1: [
      { nl: '🎪 Evenement',         en: '🎪 Event',            action: 'event' },
      { nl: '🔫 Wapenverlof',       en: '🔫 Firearms permit',  action: 'firearms' },
      { nl: '🏗️ Overig',            en: '🏗️ Other',            action: 'other' },
    ],
    2: [
      { nl: '📝 Aanvraag beoordelen', en: '📝 Review application', action: 'review' },
      { nl: '🔍 Antecedentencheck',   en: '🔍 Background check',  action: 'background' },
      { nl: '📍 Locatiecheck',        en: '📍 Location check',     action: 'location' },
    ],
    3: [
      { nl: '✅ Positief advies',    en: '✅ Positive advice',  action: 'positive' },
      { nl: '❌ Negatief advies',    en: '❌ Negative advice',  action: 'negative' },
      { nl: '⚠️ Voorwaardelijk',    en: '⚠️ Conditional',      action: 'conditional' },
    ],
    4: [
      { nl: '📄 Besluit genereren',  en: '📄 Generate decision', action: 'decision' },
      { nl: '📧 Aanvrager informeren', en: '📧 Inform applicant', action: 'inform' },
      { nl: '📜 Nieuwe vergunning',   en: '📜 New permit',        action: 'reset' },
    ],
  },

  // ── WET & PROCEDURES ──
  kennis: {
    1: [
      { nl: '⚖️ Wetboek van Strafrecht',  en: '⚖️ Criminal Code',      action: 'sr' },
      { nl: '📋 Strafvordering',           en: '📋 Criminal Procedure', action: 'sv' },
      { nl: '🚔 Politiewet',               en: '🚔 Police Act',         action: 'pw' },
    ],
    2: [
      { nl: '🔍 Gerelateerde artikelen',   en: '🔍 Related articles',   action: 'related' },
      { nl: '📊 Jurisprudentie',           en: '📊 Case law',           action: 'caselaw' },
      { nl: '📝 Praktische toepassing',    en: '📝 Practical application', action: 'practical' },
    ],
    3: [
      { nl: '📄 Samenvatting opslaan', en: '📄 Save summary',   action: 'save' },
      { nl: '📤 Delen met team',       en: '📤 Share with team', action: 'share' },
      { nl: '⚖️ Nieuw onderwerp',      en: '⚖️ New topic',      action: 'reset' },
    ],
  },

  // ── SLACHTOFFERHULP ──
  slachtoffer: {
    1: [
      { nl: '🤕 Geweldsmisdrijf',    en: '🤕 Violent crime',    action: 'violence' },
      { nl: '💰 Vermogensmisdrijf',  en: '💰 Property crime',   action: 'property' },
      { nl: '😰 Zedendelict',        en: '😰 Sexual offense',   action: 'sexual' },
    ],
    2: [
      { nl: '📞 Slachtofferhulp NL', en: '📞 Victim Support NL', action: 'vsnl' },
      { nl: '🏥 Medische hulp',      en: '🏥 Medical help',      action: 'medical' },
      { nl: '⚖️ Juridische bijstand', en: '⚖️ Legal aid',        action: 'legal' },
    ],
    3: [
      { nl: '📄 Doorverwijsbrief genereren', en: '📄 Generate referral letter', action: 'referral' },
      { nl: '📋 Schadeformulier',            en: '📋 Damage form',              action: 'damage' },
      { nl: '🤝 Nieuw gesprek',              en: '🤝 New conversation',         action: 'reset' },
    ],
  },

  // ── BURGER: AANGIFTE DOEN ──
  b_aangifte: {
    1: [
      { nl: '🏠 Inbraak',           en: '🏠 Burglary',         action: 'burglary' },
      { nl: '🚲 Diefstal',          en: '🚲 Theft',            action: 'theft' },
      { nl: '💻 Online fraude',     en: '💻 Online fraud',     action: 'fraud' },
    ],
    2: [
      { nl: '📅 Wanneer gebeurd?',  en: '📅 When did it happen?', action: 'when' },
      { nl: '📍 Waar gebeurd?',     en: '📍 Where did it happen?', action: 'where' },
      { nl: '📝 Beschrijving',      en: '📝 Description',       action: 'describe' },
    ],
    3: [
      { nl: '📄 Samenvatting bekijken', en: '📄 View summary', action: 'summary' },
      { nl: '📧 Bevestiging ontvangen', en: '📧 Get confirmation', action: 'confirm' },
      { nl: '📝 Nieuwe aangifte',       en: '📝 New report',      action: 'reset' },
    ],
  },

  // ── BURGER: RECHTEN & PLICHTEN ──
  b_rechten: {
    1: [
      { nl: '🚔 Staande gehouden',  en: '🚔 Stopped by police', action: 'stopped' },
      { nl: '🏠 Huiszoeking',       en: '🏠 House search',      action: 'search' },
      { nl: '👤 Fouillering',       en: '👤 Body search',        action: 'frisk' },
    ],
    2: [
      { nl: '📖 Meer details',      en: '📖 More details',      action: 'details' },
      { nl: '⚖️ Wet bekijken',      en: '⚖️ View law',          action: 'law' },
      { nl: '📞 Juridisch advies',  en: '📞 Legal advice',       action: 'advice' },
    ],
    3: [
      { nl: '📄 Informatie opslaan', en: '📄 Save information',  action: 'save' },
      { nl: '📧 Per e-mail ontvangen', en: '📧 Receive by email', action: 'email' },
      { nl: '⚖️ Ander onderwerp',     en: '⚖️ Other topic',       action: 'reset' },
    ],
  },

  // ── BURGER: CYBERCRIME HULP ──
  b_cyber: {
    1: [
      { nl: '💳 Bankfraude',        en: '💳 Bank fraud',        action: 'bank' },
      { nl: '📧 Phishing',          en: '📧 Phishing',          action: 'phishing' },
      { nl: '🔒 Gehackt account',   en: '🔒 Hacked account',    action: 'hacked' },
    ],
    2: [
      { nl: '🛡️ Direct beveiligen',  en: '🛡️ Secure now',       action: 'secure' },
      { nl: '📋 Bewijs verzamelen', en: '📋 Collect evidence',  action: 'evidence' },
      { nl: '📞 Helpdesk bellen',   en: '📞 Call helpdesk',     action: 'helpdesk' },
    ],
    3: [
      { nl: '📝 Online aangifte doen', en: '📝 File report online', action: 'report' },
      { nl: '🔒 Beveiligingstips',     en: '🔒 Security tips',      action: 'tips' },
      { nl: '💻 Ander probleem',       en: '💻 Other issue',         action: 'reset' },
    ],
  },

  // ── BURGER: SLACHTOFFERHULP ──
  b_slachtoffer: {
    1: [
      { nl: '🤕 Fysiek geweld',     en: '🤕 Physical violence', action: 'physical' },
      { nl: '💰 Financieel',        en: '💰 Financial',         action: 'financial' },
      { nl: '😰 Huiselijk geweld',  en: '😰 Domestic violence', action: 'domestic' },
    ],
    2: [
      { nl: '📞 Slachtofferhulp: 0900-0101', en: '📞 Victim Support: 0900-0101', action: 'call' },
      { nl: '🏥 Veilig Thuis: 0800-2000',    en: '🏥 Safe Home: 0800-2000',      action: 'safe_home' },
      { nl: '⚖️ Schadefonds Geweldsmisdrijven', en: '⚖️ Violent Crimes Fund',     action: 'fund' },
    ],
    3: [
      { nl: '📧 Informatie per e-mail', en: '📧 Info by email',    action: 'email' },
      { nl: '📍 Hulp bij mij in de buurt', en: '📍 Help near me', action: 'nearby' },
      { nl: '🤝 Ander onderwerp',       en: '🤝 Other topic',     action: 'reset' },
    ],
  },
};
